import { Component } from 'preact';
import { DOMAIN } from '@globals';

import style from './style';

import { Link } from 'preact-router/match';

import Image from '@components/image';
import Text from '@components/translate';
import SearchField from '@components/searchfield';
import JSONLD from '@components/jsonld';
import { Button } from '@components/button';
import { Stateful } from '@components/pubsub';
import I18n from '@i18n';
import MobileHeader from '@components/mobile-header';

class Header extends Component {
  state = {
    show: false,
  };
  toggleCitySelector = () => {
    this.setState({ show: !this.state.show });
  };
  render({ breadcrumbs = [], dark }, state, { lang }) {
    return (
      <navigation class={style.navigation}>
        {/* Mobile Header - visible only on mobile */}
        <MobileHeader dark={dark} />

        {/* Desktop Header - hidden on mobile */}
        <main class={`${style.header} ${dark ? style.dark : style.light}`}>
          <div class={`${style.logoContainer} contain`}>
            <div class={style.logoWrapper}>
              <a href={`/${lang}`} class={style.logo}>
                <img
                  height="20"
                  class={style.tableOnlineLogo}
                  src="/assets/logo/TableOnline_Logo_White_Eggshell.svg"
                  alt="TableOnline Logo"
                />
              </a>
            </div>

            <div class={style.searchContainer}>
              <SearchField showCityFilter={false} />
            </div>

            <nav>
              <div class={style.authContainer}>
                <Stateful events={['auth']}>
                  {({ auth }) =>
                    auth ? (
                      <Button
                        href={`/${lang}/profile`}
                        class={style.authButton}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          style="margin-right: 0.5rem;"
                        >
                          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                          <circle cx="12" cy="7" r="4"></circle>
                        </svg>
                        {auth.firstname}
                      </Button>
                    ) : (
                      <div class={style.authButtons}>
                        <Button
                          href={`/${lang}/profile`}
                          class={style.authButton}
                        >
                          {I18n.t('Login')}
                        </Button>
                        <Button
                          href={`/${lang}/profile?view=create`}
                          class={`${style.authButton} ${style.signupButton}`}
                        >
                          {I18n.t('Create account')}
                        </Button>
                      </div>
                    )
                  }
                </Stateful>
              </div>

              {window.tableOnlineShowProfile ? (
                <ul class={style.navigationIcons}>
                  <li>
                    <Link
                      activeClassName={style.active}
                      class={style.link}
                      href={`/${lang}/about`}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                      >
                        <path
                          d="M12 24c6.627 0 12-5.373 12-12s-5.373-12-12-12-12 5.373-12 12 5.373 12 12 12zm1-6h-2v-8h2v8zm-1-12.25c.69 0 1.25.56 1.25 1.25s-.56 1.25-1.25 1.25-1.25-.56-1.25-1.25.56-1.25 1.25-1.25z"
                          fill={dark ? '#eee' : '#aaa'}
                        />
                      </svg>
                      <Text span class={style.hideOnMobile}>{I18n.t("About us")}</Text>
                    </Link>
                  </li>
                </ul>
              ) : null}
            </nav>
          </div>
        </main>

        {/* Breadcrumbs JSON-LD data still needed for SEO */}
        {breadcrumbs.length ? (
          <JSONLD>
            {{
              '@context': 'https://schema.org',
              '@type': 'BreadcrumbList',
              itemListElement: breadcrumbs.map((item, index) => ({
                '@type': 'ListItem',
                position: index + 1,
                name: item.title,
                item: `${DOMAIN}${item.link}`,
              })),
            }}
          </JSONLD>
        ) : null}
      </navigation>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./components/header/index.js